import { render, staticRenderFns } from "./TypeMaintenanceForm.vue?vue&type=template&id=40d7b0a4&"
import script from "./TypeMaintenanceForm.vue?vue&type=script&lang=js&"
export * from "./TypeMaintenanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports